import React, { useState } from 'react'
import { useParams, useHistory } from 'react-router-dom'

import { Button, Col, Form, Input, Row, SelectPicker, Toggle, Panel } from 'rsuite'

import ShopTopMenu from '@components/shop/ShopTopMenu'
import { useCreateStorageContainer } from '@@partner:graphql/mutation/storageContainer/createStorageContainer.gql'
import { CreateStorageContainerInput } from '@@partner:types:app'
import { generatePath } from 'react-router-dom'
import { ROUTE_STORAGE_CONTAINERS } from '@@partner:config/routes'
import { CONTAINER_SIZES, CONTAINER_TYPES } from '../../constants/storageContainer'

export default function CreateStorageContainerPage () {
  const { brandSlug } = useParams<any>()
  const history = useHistory()
  
  const [ createContainer, { loading } ] = useCreateStorageContainer()
  
  const [ formData, setFormData ] = useState<CreateStorageContainerInput>({
    container_id: '',
    size: 'M',
    type: 'container',
    description: '',
    is_active: true
  })

  const sizeOptions = CONTAINER_SIZES

  const typeOptions = CONTAINER_TYPES

  const handleSubmit = async () => {
    try {
      await createContainer({
        variables: {
          input: formData
        }
      })
      
      history.push(generatePath(ROUTE_STORAGE_CONTAINERS, { brandSlug }))
    }
    catch (error) {
      console.error('Error creating container:', error)
    }
  }

  const handleFieldChange = (field: keyof CreateStorageContainerInput) => (value: any) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }))
  }

  return (
    <div>
      <ShopTopMenu />
      
      <Panel header="Создание нового контейнера" bordered>
        <Form layout="horizontal">
          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Group>
                <Form.ControlLabel>Код контейнера *</Form.ControlLabel>
                <Input
                  value={formData.container_id}
                  onChange={handleFieldChange('container_id')}
                  placeholder="Введите уникальный код..."
                  required
                />
                <Form.HelpText>
                  Уникальный идентификатор контейнера (штрих-код, QR-код)
                </Form.HelpText>
              </Form.Group>
            </Col>

            <Col xs={24} sm={12}>
              <Form.Group>
                <Form.ControlLabel>Размер *</Form.ControlLabel>
                <SelectPicker
                  data={sizeOptions}
                  value={formData.size}
                  onChange={handleFieldChange('size')}
                  placeholder="Выберите размер"
                  searchable={false}
                  cleanable={false}
                  style={{ width: '100%' }}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col xs={24} sm={12}>
              <Form.Group>
                <Form.ControlLabel>Тип *</Form.ControlLabel>
                <SelectPicker
                  data={typeOptions}
                  value={formData.type}
                  onChange={handleFieldChange('type')}
                  placeholder="Выберите тип"
                  searchable={false}
                  cleanable={false}
                  style={{ width: '100%' }}
                />
              </Form.Group>
            </Col>

            <Col xs={24} sm={12}>
              <Form.Group>
                <Form.ControlLabel>Активен</Form.ControlLabel>
                <Toggle
                  checked={formData.is_active}
                  onChange={handleFieldChange('is_active')}
                />
                <Form.HelpText>
                  Контейнер будет доступен для использования
                </Form.HelpText>
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col xs={24}>
              <Form.Group>
                <Form.ControlLabel>Описание</Form.ControlLabel>
                <Input
                  as="textarea"
                  rows={3}
                  value={formData.description}
                  onChange={handleFieldChange('description')}
                  placeholder="Дополнительное описание контейнера..."
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col xs={24}>
              <Form.Group>
                <Button
                  appearance="primary"
                  onClick={handleSubmit}
                  loading={loading}
                  disabled={!formData.container_id || !formData.size || !formData.type}
                >
                  Создать контейнер
                </Button>
                <Button
                  appearance="subtle"
                  onClick={() => history.goBack()}
                  style={{ marginLeft: 8 }}
                >
                  Отмена
                </Button>
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </Panel>
    </div>
  )
}
